// extracted by mini-css-extract-plugin
export var container = "_s8-0";
export var table = "_s8-2";
export var tableWrapper = "_s8-1";